import type { StaffOrderDetail } from "@/api/staff";

interface Props {
  orderInfo?: StaffOrderDetail;
}

const STEPS = [
  { label: "接单", key: "status", val: 10 },
  { label: "签约", key: "status", val: 16 },
  { label: "出发", key: "is_depart", val: 1 },
  { label: "到达", key: "is_depart", val: 2 },
  { label: "服务", key: "is_depart", val: 3 },
  { label: "完成", key: "status", val: 40 },
] as const;

export function ProgressDots({ orderInfo }: Props) {
  return (
    <div className="flex items-center justify-between px-1 pt-5 pb-2">
      {STEPS.map((step, i) => {
        const isSignStep = i === 1;
        const isDepartStep = i === 2;
        let active = false;
        if (isSignStep) {
          // 签约：status >= 16 即视为已签约（后续步骤也应保持亮起）
          active = (orderInfo?.status ?? 0) >= step.val;
        } else if (isDepartStep) {
          // 出发：已出发(is_depart>=1) 或 签约完成但未出发(status>=16 && is_depart<1) → 均亮起
          const depart = orderInfo?.is_depart ?? 0;
          const st = orderInfo?.status ?? 0;
          active = depart >= 1 || (st >= 16 && depart < 1);
        } else if (step.key === "status") {
          active = (orderInfo?.status ?? 0) > (step.val === 40 ? 30 : step.val);
        } else {
          active = (orderInfo?.[step.key as keyof StaffOrderDetail] ?? 0) >= step.val;
        }

        return (
          <div key={i} className="flex items-center flex-1 last:flex-none">
            {/* 节点圆点 */}
            <div className="flex flex-col items-center">
              <div
                className={`w-2.5 h-2.5 rounded-full transition-colors ${
                  active ? "bg-[#FE7A3A]" : "bg-white/30"
                }`}
              />
              <span
                className={`text-[10px] mt-1 whitespace-nowrap ${
                  active ? "text-[#FE7A3A]/90" : "text-white/40"
                }`}
              >
                {step.label}
              </span>
            </div>
            {/* 连线 */}
            {i < STEPS.length - 1 && (
              <div className="flex-1 h-[2px] mx-0.5 mt-[-10px]">
                <div
                  className="h-full transition-colors"
                  style={{
                    background: active
                      ? "linear-gradient(90deg, #FE7A3A, rgba(254,122,58,0.3))"
                      : "rgba(255,255,255,0.15)",
                  }}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
